import { lazy } from "react";

export const Login = lazy(() => import("src/pages/Login"));
export const ZoomInstallation = lazy(() => "src/pages/auth/ZoomInstallation");
export const Register = lazy(() => import("src/pages/Register"));
export const ConfirmEmail = lazy(() => import("src/pages/ConfirmEmail"));
export const ResetPassword = lazy(() => import("src/pages/ResetPassword"));
export const NewPassword = lazy(() => import("src/pages/NewPassword"));
export const CheckEmail = lazy(() => import("src/pages/CheckEmail"));
export const SendToolRedirect = lazy(() =>
  import("src/pages/SendToolRedirect")
);
export const VerifyEmail = lazy(() => import("src/pages/auth/VerifyEmail"));
export const Onboarding = lazy(() => import("src/pages/auth/Onboarding"));
export const Setup = lazy(() => import("src/pages/auth/Setup"));
export const AccountView = lazy(() =>
  import("src/pages/auth/Account/AccountView")
);
export const Home = lazy(() => import("src/pages/auth/Home"));

export const OldAgendaView = lazy(() =>
  import("src/components/Agenda/AgendaView")
);
export const NewAgendaView = lazy(() =>
  import("src/components/Agenda/NewAgendaView")
);
export const AgendaDetailView = lazy(() =>
  import("src/components/Agenda/AgendaDetailView")
);
export const SelectUserType = lazy(() => import("@pages/auth/SelectUserType"));
export const WebUserJoinMeeting = lazy(() =>
  import("@pages/auth/WebUserJoinMeeting")
);
export const EditProfile = lazy(() =>
  import("@components/Profile/EditProfile")
);
export const BillingView = lazy(() =>
  import("@components/Billing/BillingView")
);
export const WebMeetingJoin = lazy(() =>
  import("src/pages/meeting/WebMeetingJoin")
);
export const WebMeetingCodeEntry = lazy(() =>
  import("src/pages/meeting/WebMeetingCodeEntry")
);
export const SmartAgendas = lazy(() => import("src/pages/pro/SmartAgendas"));
export const SmartAgendasSetup = lazy(() =>
  import("src/pages/pro/SmartAgendas")
);
export const ReportsView = lazy(() =>
  import("src/components/Reports/ReportsView")
);
export const ReportDetailView = lazy(() =>
  import("src/components/Reports/ReportDetailView")
);
export const NewsView = lazy(() => import("src/components/News/NewsView"));
export const RouteRedirector = lazy(() =>
  import("src/components/RouteRedirector")
);
export const TrySmartAgenda = lazy(() => import("src/pages/TrySmartAgenda"));
